const setLoadingInTeamList = (list, ids, loading) =>
	list.map((team) => {
		const newTeam = {...team, linkStatusLoading: false};
		if (ids.includes(parseInt(team.id || team.teamId))) {
			newTeam.linkStatusLoading = loading;
		}
		return newTeam;
	});

const setLoadingInScopeList = (list, ids, loading) =>
	list.map((scope) => ({...scope, teamList: setLoadingInTeamList(scope.teamList, ids, loading)}));

export default (list, ids, loading, nested = false) => {
	const newList = nested ? setLoadingInScopeList(list, ids, loading) : setLoadingInTeamList(list, ids, loading);
	return newList;
};
